var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadIllustration = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 16.8h6v6.4H36V36H4V23.2h3.2v-6.4h6V4h13.6v12.8zM4.4 35.6h2.8v-12H4.4v12zm3.2 0H10v-12H7.6v12zm0-12.4h2.8v12.4h2.8V17.2H7.6v6zm6 12.4h2.8V17.2h-2.8v18.4zm0-18.8h3.2v18.8h3V4.4h-6.2v12.4zm6.6 18.8h3V16.8h3.2V4.4h-6.2v31.2zm3.4 0h2.8V17.2h-2.8v18.4zm9.2 0h2.8v-12h-2.8v12zm-2.8 0h2.4v-12H30v12zm-3.2 0h2.8V23.2h2.8v-6h-5.6v18.4z",
    fill: "#fff"
  })));
};
export default SvgUploadIllustration;